// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"32caffb4","496":"e7899a8a","737":"da1e5f6b","770":"de4505a3"}[chunkId] + ".chunk.js";
};